import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { BfwGeneralDataService, PhraseAutocomplete, Recommended } from 'generatedBfw/static';

export const AutocompleteSearchRecommendedUrl = `/elysium-api/general/v1/search/recommended`;
const AutocompleteSearchRecommendedQueryKey = 'mostPopularSearches';

export const AutocompleteSearchUrlBase = `/elysium-api/general/v1/search/autocomplete`;

const AutocompleteSearchQueryKey = (phrase: string) => ['search', 'suggestions', phrase];

export function useMostPopularSearches() {
  return useQuery<Recommended>([AutocompleteSearchRecommendedQueryKey], () =>
    BfwGeneralDataService.getRecommended(),
  );
}

export function useSuggestions(phrase: string, options?: UseQueryOptions<PhraseAutocomplete>) {
  return useQuery<PhraseAutocomplete>(
    AutocompleteSearchQueryKey(phrase),
    () => BfwGeneralDataService.getSearchAutocomplete(phrase),
    options,
  );
}
